module.exports = __webpack_public_path__ + "img/item_Portrait_02.4aca468e.jpeg";